<template>
  <div class="main">
    <div class="title">
      <img :src="require('@/assets/work/title01.svg')" style="width: 60%;margin-top: 10%;"/>
      <img :src="require('@/assets/work/title02.svg')" style="width: 60%;margin-top: 2%;"/>
      <div style="color: #6C5141;margin-top: 20px;">——员工油费补贴福利——</div>      
    </div>
    <div class="title" :style="'padding: 0 24px;margin-top:'+ Height +'px;'">
      <!-- <div style="font-size: 20px;margin-bottom: 20px;">更多同行   更少等待</div> -->
      <van-button round color="rgba(51, 51, 51, 0.92)" type="primary" size="large" block @click="showRole = true">点我开启早班拼车</van-button>
      <div class="company">由营销信息部提供技术支持</div>
    </div>
    <van-popup
      v-model="showRole"
      closeable
      round
      position="bottom"
      :close-on-click-overlay="false"
      style="height:250px;">
      <div class="popup-title">请选择早班车身份</div>
      <van-radio-group v-model="Role" style="margin:0 16px;">
        <div
          class="popup-radio-box"
          @click="checkRadio('passenger')"
          :style="Role === 'passenger' ? 'background: rgba(254, 176, 19, 0.1);': ''">
          <div>
            <div style="font-weight: bold;">我是乘客</div>
            <div style="color: #999999;font-size:12px;">寻找顺路司机，高效通勤</div>
          </div>
          <van-radio name="passenger" checked-color="#FEB013"/>
        </div>
        <div
          class="popup-radio-box"
          @click="checkRadio('driver')"
          :style="Role === 'driver' ? 'background: rgba(254, 176, 19, 0.1);': ''">
          <div>
            <div style="font-weight: bold;">我是司机</div>
            <div style="color: #999999;font-size:12px;">寻找顺路乘客，公司补贴油费</div>
          </div>
          <van-radio name="driver" checked-color="#FEB013"/>
        </div>
      </van-radio-group>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
        WXInfo: {},
        form: {},
        showRole: false,
        Role: '',
        Height: window.innerHeight -270,
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.form.Name = this.WXInfo.name
    this.form.UserId = this.WXInfo.userid
    this.form.Phone = this.WXInfo.mobile
  },
  methods: {
    checkRadio(val) {
      this.showRole = false
      if (val === 'driver') {
        this.$router.push('/work/apply?workrole=' + val)
      } else {
        this.$router.push('/work/index?workrole=' + val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    height: 100vh;
    background: center no-repeat url('~@/assets/work/login.png'), linear-gradient(180deg, #FEB013 0%, #FFF 100%);
    background-size: contain;
  }
  .title {
    text-align: center;
  }
  .company {
    color: #999;
    text-align: center;
    font-size: 12px;
    padding-top: 8px;
  }
  .popup-title {
    text-align: center;
    padding: 16px;
  }
  .popup-radio-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1.5;
    border-radius: 4px;
    background: #F5F5F5;
    padding: 12px;
    margin: 8px 0;
  }
  .approve {
    color:#F22222;
    text-decoration-line: underline;
    font-weight: 600;
  }
</style>
